<template>
  <div class="sh-ri content-main">
    <!-- BUIL -->
    <pulse-loader
      :loading="loading"
      :color="color"
      :size="size"
      class="vue-loader"
    ></pulse-loader>
    <div class="sh-ri-content">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title-index">
              <h2>
                Ranking regional
                <span
                  v-b-tooltip.hover
                  title="Considera-se apenas equipes (eAP e eSF) válidas para o componente de desempenho"
                  class="icon-tooltip"
                >
                  <i class="icofont-info-circle" style="font-size: 20px"></i>
                </span>
              </h2>
            </div>
          </div>
          <div class="col-lg-4 col-md-12">
            <div class="form-group">
              <vue-select
                id="quadrimestre"
                name="quadrimestre"
                :options="quadrimestres"
                label="quadrimestre"
                placeholder="QUADRIMESTRE"
                @input="onChangeQuadrimestre"
                class="grafico-select"
                v-model="quadrimestre"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <div class="col-lg-4 col-12">
            <vue-select
              :options="regions"
              label="label"
              placeholder="REGIÃO"
              @input="onChangeRegions"
              class="grafico-select"
              :disabled="disabelRegions"
              v-model="region"
            >
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
          <div class="col-lg-4 col-12">
            <vue-select
              :options="states"
              label="uf"
              placeholder="UF"
              @input="onChangeStates"
              class="grafico-select"
              :disabled="disableStates"
              v-model="state"
            >
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
          <div class="col-lg-4 col-12">
            <vue-select
              :options="macroRegions"
              label="uf"
              placeholder="MACRO REGIÃO"
              @input="onChangeMacroRegion"
              class="grafico-select"
              :disabled="disableMacroRegion"
              v-model="macroRegion"
            >
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
          <div class="col-lg-4 col-12">
            <vue-select
              :options="regional"
              label="REGIONAL"
              placeholder="REGIONAL"
              @input="onChangeRegional"
              class="grafico-select"
              :disabled="disableRegional"
              v-model="regionalValue"
            >
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
          <!--           <div class="col-lg-4 col-12">
            <vue-select
              :options="populations"
              label="label"
              placeholder="POPULAÇÃO"
              @input="onChangePopulations"
              class="grafico-select"
              v-model="population"
              :disabled="disablePopulation"
            >
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div> -->
          <!--    <div class="col-lg-4 col-12">
            <vue-select
              multiple
              :options="dataIsf"
              label="label"
              placeholder="ISF"
              @input="onChangeIsf"
              class="grafico-select"
              :disabled="disableIsf"
              v-model="isf"
            >
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div> -->
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="sh-ri-info">
              <h3>{{ info.title }}</h3>
              <div class="sh-ri-percent" v-if="info.type == 'pre-natal'">
                <div class="sh-ri-percent-red"><span></span> < 18%</div>
                <div class="sh-ri-percent-orange">
                  <span></span> >= 18% e < 31%
                </div>
                <div class="sh-ri-percent-green">
                  <span></span> >= 31% e < 45%
                </div>
                <div class="sh-ri-percent-blue"><span></span> >= 45%</div>
              </div>
              <div
                class="sh-ri-percent"
                v-if="
                  info.type == 'hiv-sifilis' ||
                  info.type == 'consultas-odontologicas'
                "
              >
                <div class="sh-ri-percent-red"><span></span> < 24%</div>
                <div class="sh-ri-percent-orange">
                  <span></span> >= 24% e < 42%
                </div>
                <div class="sh-ri-percent-green">
                  <span></span> >= 42% e < 60%
                </div>
                <div class="sh-ri-percent-blue"><span></span> >= 60%</div>
              </div>
              <div class="sh-ri-percent" v-if="info.type == 'citopatologico'">
                <div class="sh-ri-percent-red"><span></span> < 16%</div>
                <div class="sh-ri-percent-orange">
                  <span></span> >= 16% e < 28%
                </div>
                <div class="sh-ri-percent-green">
                  <span></span> >= 28% e < 40%
                </div>
                <div class="sh-ri-percent-blue"><span></span> >= 40%</div>
              </div>
              <div class="sh-ri-percent" v-if="info.type == 'polio-penta'">
                <div class="sh-ri-percent-red"><span></span> < 38%</div>
                <div class="sh-ri-percent-orange">
                  <span></span> >= 38% e < 67%
                </div>
                <div class="sh-ri-percent-green">
                  <span></span> >= 67% e < 95%
                </div>
                <div class="sh-ri-percent-blue"><span></span> >= 95%</div>
              </div>
              <div
                class="sh-ri-percent"
                v-if="
                  info.type == 'hipertensao' ||
                  info.type == 'hemoglobina-glicada'
                "
              >
                <div class="sh-ri-percent-red"><span></span> < 20%</div>
                <div class="sh-ri-percent-orange">
                  <span></span> >= 20% e < 35%
                </div>
                <div class="sh-ri-percent-green">
                  <span></span> >= 35% e < 50%
                </div>
                <div class="sh-ri-percent-blue"><span></span> >= 50%</div>
              </div>
              <div class="sh-ri-percent" v-if="info.type == 'isf'">
                <div class="sh-ri-percent-red"><span></span> < 4.0</div>
                <div class="sh-ri-percent-orange">
                  <span></span> >= 4.0 e < 7.0
                </div>
                <div class="sh-ri-percent-green">
                  <span></span> >= 7.0 e <= 9.0
                </div>
                <div class="sh-ri-percent-blue"><span></span> > 9.0</div>
              </div>
              <div class="sh-ri-percent" v-if="info.type == 'desempenho'">
                <!-- <div class="sh-ri-percent-red">
                                    <span></span> < 40%
                                </div>
                                <div class="sh-ri-percent-orange">
                                    <span></span> >= 40% e < 70%
                                </div>
                                <div class="sh-ri-percent-green">
                                    <span></span> >= 70% e <= 90%
                                </div>
                                <div class="sh-ri-percent-blue">
                                    <span></span> > 90%
                                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="box" style="margin-top: 10px">
          <table class="table table-responsive table-striped" id="table">
            <thead class="thead-light fixed-header">
              <tr>
                <th>TEM</th>

                <th class="text-left">
                  {{ trDinamica() }}
                </th>
                <th class="text-left" @mouseover="updateInfo('municipio')">
                  MUNICÍPIO
                </th>
                <th @mouseover="updateInfo('pre-natal')">I1</th>
                <th @mouseover="updateInfo('hiv-sifilis')">I2</th>
                <th @mouseover="updateInfo('consultas-odontologicas')">I3</th>
                <th @mouseover="updateInfo('citopatologico')">I4</th>
                <th @mouseover="updateInfo('polio-penta')">I5</th>
                <th @mouseover="updateInfo('hipertensao')">I6</th>
                <th @mouseover="updateInfo('hemoglobina-glicada')">I7</th>
                <th @mouseover="updateInfo('isf')">ISF</th>
                <th @mouseover="updateInfo('desempenho')">DESEMPENHO</th>
                <th>QUADRIMESTRE</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dados" :key="index">
                <td v-if="item.status != null && item.status == 1">
                  <a href="https://esusfeedback.com.br/" target="_blank">
                    <img
                      src="@/assets/images/logo-mini.png"
                      alt=""
                      style="width: 40px"
                    />
                  </a>
                </td>
                <td v-else>
                  <a href="https://esusfeedback.com.br/" target="_blank">
                    <img
                      src="@/assets/images/logo-feedback-black.png"
                      alt=""
                      style="width: 40px"
                    />
                  </a>
                </td>
                <td>
                  {{ tdDinamica() }}
                </td>
                <td class="text-left btn-options">
                  <div class="placement" v-if="nomeMunicipio == ''">
                    <span v-bind:class="changeFontColor(parseFloat(item.isf))"
                      >{{ index + 1 }}°</span
                    >
                    {{ item.no_municipio }} - {{ item.no_uf }}
                  </div>
                </td>
                <td
                  v-bind:class="
                    indicadorColor(item.pn_6_consultas, 'pre-natal')
                  "
                >
                  {{ item.pn_6_consultas }}
                </td>
                <td
                  v-bind:class="
                    indicadorColor(item.pn_hiv_sifilis, 'hiv-sifilis')
                  "
                >
                  {{ item.pn_hiv_sifilis }}
                </td>
                <td
                  v-bind:class="
                    indicadorColor(
                      item.pn_odontologia,
                      'consultas-odontologicas'
                    )
                  "
                >
                  {{ item.pn_odontologia }}
                </td>
                <td
                  v-bind:class="
                    indicadorColor(item.citopatologico, 'citopatologico')
                  "
                >
                  {{ item.citopatologico }}
                </td>
                <td
                  v-bind:class="
                    indicadorColor(item.crianca_polio_penta, 'polio-penta')
                  "
                >
                  {{ item.crianca_polio_penta }}
                </td>
                <td
                  v-bind:class="
                    indicadorColor(item.pa_hipertensao, 'hipertensao')
                  "
                >
                  {{ item.pa_hipertensao }}
                </td>
                <td
                  v-bind:class="
                    indicadorColor(item.hg_diabetes, 'hemoglobina-glicada')
                  "
                >
                  {{ item.hg_diabetes }}
                </td>
                <td>
                  <div
                    class="sh-re-button-isf"
                    v-bind:class="changeFontColor(parseFloat(item.isf))"
                  >
                    {{ item.isf }}
                  </div>
                </td>
                <td>
                  {{ item.desempenho }}
                </td>
                <td>
                  {{ item.quadrimestre }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import {
  LMap,
  LTileLayer,
  LCircleMarker,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
} from 'vue2-leaflet'
import { latLng, icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { coordinates } from './coordinates.js'
import { statesBR } from './states.js'

export default {
  name: 'listaRegional',
  components: {
    PulseLoader,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LCircleMarker,
    LTooltip,
    LControlZoom,
    'vue-select': VueSelect,
  },
  data() {
    return {
      steps: '',
      zoom: 5,
      center: latLng(-15.2, -51.31),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      icon: icon({
        iconUrl: 'static/images/baseball-marker.png',
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      staticAnchor: [16, 37],
      customText: 'Foobar',
      iconSize: 64,
      regions: [
        {
          value: 'sul',
          label: 'Sul',
        },
        {
          value: 'sudeste',
          label: 'Sudeste',
        },
        {
          value: 'norte',
          label: 'Norte',
        },
        {
          value: 'nordeste',
          label: 'Nordeste',
        },
        {
          value: 'centro-oeste',
          label: 'Centro-Oeste',
        },
      ],
      region: [],
      population: [],
      populations: [
        {
          value: 'de 50.001 a 100.000',
          label: 'de 50.001 a 100.000',
        },
        {
          value: 'de 5.001 a 10.000',
          label: 'de 5.001 a 10.000',
        },
        {
          value: 'de 20.001 a 50.000',
          label: 'de 20.001 a 50.000',
        },
        {
          value: 'de 100.001 a 500.000',
          label: 'de 100.001 a 500.000',
        },
        {
          value: 'de 10.001 a 20.000',
          label: 'de 10.001 a 20.000',
        },
        {
          value: 'até 5.000',
          label: 'até 5.000',
        },
        {
          value: 'acima de 500.000 hab.',
          label: 'acima de 500.000 hab.',
        },
      ],
      dataIsf: [
        {
          value: 'ISF < 4,0',
          label: 'ISF < 4,0',
        },
        {
          value: 'ISF > 3,9 e < 7,0',
          label: 'ISF > 3,9 e < 7,0',
        },
        {
          value: 'ISF > 6,9 e < 10,0',
          label: 'ISF > 6,9 e < 10,0',
        },
        {
          value: 'ISF  = 10,0',
          label: 'ISF = 10,0',
        },
      ],
      state: '',
      states: [],
      /*     states: [...statesBR], */
      macroRegion: [],
      macroRegions: [],
      regional: [],
      regionalValue: '',
      isf: [],
      markersFilter: [],
      dataToFilter: [],
      disabelRegions: true,
      disableStates: true,
      disablePopulation: false,
      disableMacroRegion: true,
      disableRegional: true,
      disableIsf: true,
      dataFilterCitiesRegion: [],
      dataFilterPopulation: [],
      dataFilterMacroRegions: [],
      dataFilterRegional: [],
      dataFilterIsf: [],
      info: {
        type: 'municipio',
        title:
          'Os primeiros da lista são municípios com melhor desempenho, ou seja, ISF mais alto.',
      },
      dados: [],
      dadosOriginaisDaRequisicao: [],
      nomeMunicipio: '',
      loading: false,
      loadingPdf: false,
      municipio: '',
      quadrimestre: '',
      quadrimestres: [],
      temEstadoSelecionado: false,
      size: '40px',
      color: '#0D98BB',
      openedModal: false,
      openedModalSeloAps: false,
      openedModalPorcentagem: false,
      seloApsImg: '',
      porcentagemImg: '',
    }
  },
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15]
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15]
    },
  },
  async mounted() {
    document.body.style.overflow = 'unset'
    await this.buscarQuadrimestres()
  },
  methods: {
    trDinamica() {
      if (this.steps === 'regiao') {
        return 'Região'
      }
      if (this.steps === 'estado') {
        return 'UF'
      }
      if (this.steps === 'macroRegiao') {
        return 'Macro Região'
      }
      if (this.steps === 'regional') {
        return 'Regional'
      }
      if (this.steps === 'populacao') {
        return 'População'
      }
    },
    tdDinamica() {
      if (this.steps === 'regiao') {
        return this.region.label.replace('-', ' ')
      }
      if (this.steps === 'estado') {
        return this.state
      }
      if (this.steps === 'macroRegiao') {
        return this.macroRegion
      }
      if (this.steps === 'regional') {
        return this.regionalValue
      }
      if (this.steps === 'populacao') {
        return this.population.value
      }
    },
    filter(
      dataFilterCitiesRegion,
      dataFilterPopulation,
      dataFilterMacroRegions,
      dataFilterRegional
    ) {
      let data = []
      data = this.dadosOriginaisDaRequisicao
      // Busca todas cidades da região
      if (dataFilterCitiesRegion.length > 0) {
        data = this.allCitiesInRegion(dataFilterCitiesRegion)
      }

      // busca todas as cidades do estado

      if (this.state !== '') {
        data = this.allCitiesByState(this.state)
      }

      // filtra por população
      if (dataFilterPopulation.length > 0) {
        data = this.citiesByPopulation(dataFilterPopulation)
      }

      // filtra por macro região
      if (dataFilterMacroRegions.length > 0) {
        data = this.citiesByMacroRegions(
          data,
          this.state,
          dataFilterMacroRegions
        )
      }

      // filtra por regional
      if (dataFilterRegional.length > 0) {
        data = this.citiesByRegional(data, this.state, dataFilterRegional)
      }

      // Busca por quadrimestre
      /*  if (this.quadrimestre !== '') {
        data = this.filterByQuadrimestre(data)
      } */
      this.dados = data
    },

    async onChangeRegions(event) {
      this.dados = []
      this.dadosOriginaisDaRequisicao = []
      if (event !== null) {
        this.steps = 'regiao'
        this.disableStates = false
        this.state = ''
        this.states = []
        this.macroRegions = []
        this.population = []
        this.dataFilterCitiesRegion = ''
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []

        this.region = event
        const dataUf = []
        dataUf.push(event.value)

        const dataRegion = statesBR.filter((item) => {
          return dataUf.includes(item.region)
        })

        this.states = dataRegion
        this.dataFilterCitiesRegion = dataRegion.map((element) => {
          return element.uf
        })
        // Busca todos os dados
        await this.allCities(false)

        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      } else {
        this.steps = ''
        this.state = ''
        this.states = []
        this.macroRegions = []
        this.population = []
        this.dataFilterCitiesRegion = ''
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []

        // Disabled
        this.disableStates = true
        this.disableMacroRegion = true
        this.disableRegional = true
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },

    onChangeStates(event) {
      this.steps = 'estado'
      this.dataFilterRegional = []
      this.regionalValue = ''
      this.disableRegional = true
      if (event !== null) {
        this.dataFilterMacroRegions = []
        this.dataFilterRegional = []
        this.macroRegion = []
        this.macroRegions = []
        this.population = []
        this.state = event.uf
        this.regional = []
        this.disableMacroRegion = false

        // busca as macro regiões do estado
        this.allMacroRegionByState(this.state)
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      } else {
        this.steps = 'regiao'
        this.state = ''
        this.regional = []
        this.population = []
        this.macroRegion = []
        this.macroRegions = []
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []

        // Disabled
        this.disableMacroRegion = true
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },

    onChangePopulations(event) {
      // Disabled
      this.disableStates = true
      this.disableMacroRegion = true
      this.disableRegional = true
      this.dataFilterRegional = []
      this.regionalValue = ''

      this.dados = []
      this.dadosOriginaisDaRequisicao = []

      if (event !== null) {
        this.steps = 'populacao'
        const dataFilterPopulation = []

        dataFilterPopulation.push(event.value)

        this.dataFilterPopulation = dataFilterPopulation

        // Limpas os outros campos
        this.state = ''
        this.states = []
        this.region = []
        this.regional = []
        this.macroRegion = []
        this.macroRegions = []
        this.dataFilterCitiesRegion = []
        this.dataFilterMacroRegions = []
        this.dataFilterRegional = []

        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      } else {
        this.steps = ''
        this.population = []
        this.dataFilterPopulation = []
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },

    onChangeMacroRegion(event) {
      this.steps = 'macroRegiao'
      this.dataFilterRegional = []
      this.regionalValue = ''
      if (event !== null) {
        const dataFilterMacroRegions = []
        dataFilterMacroRegions.push(event)
        this.dataFilterMacroRegions = dataFilterMacroRegions

        // busca as regiões do estado
        this.allRegionalByState(this.state, event)
        this.disableMacroRegion = false
        this.disableRegional = false
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      } else {
        this.steps = 'estado'
        this.macroRegion = []
        this.disableRegional = true
        this.dataFilterMacroRegions = []
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },

    onChangeRegional(event) {
      if (event !== null) {
        this.steps = 'regional'
        const dataFilterRegional = []
        dataFilterRegional.push(event)
        this.dataFilterRegional = dataFilterRegional
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      } else {
        this.steps = 'macroRegiao'
        this.regionalValue = ''
        this.dataFilterRegional = []
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },
    async allCities(dadosPopulacao) {
      try {
        this.loading = true
        let url = ''
        if (dadosPopulacao === false) {
          url = `previne-brasil/ranking/regional/${this.region.label}/${this.quadrimestre}`
        } else {
          url = `previne-brasil/ranking/regional/${this.region.label}/${this.quadrimestre}`
        }
        let response = await this.$apiPublic.get(url)
        if (response) {
          this.dados = response.data
          this.dadosOriginaisDaRequisicao = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    // Buscas todos registros de todas cidades da região
    allCitiesInRegion(cities) {
      const allData = this.dadosOriginaisDaRequisicao
      const dataCity = allData.filter((item) => {
        return cities.includes(item.no_uf)
      })
      // Passa a data e o limite de municipios
      return this.ordenando(dataCity, 100)
    },

    // Ordena os regitros por isf e por desempenho
    ordenando(data, limit) {
      const ordenado = data.sort((a, b) => {
        if (Number(a.isf) === Number(b.isf)) {
          if (Number(a.desempenho) < Number(b.desempenho)) return 1
          if (Number(a.desempenho) > Number(b.desempenho)) return -1
          return 0
        } else {
          if (Number(a.isf) < Number(b.isf)) return 1
          if (Number(a.isf) > Number(b.isf)) return -1
          return 0
        }
      })
      if (limit) {
        let ordenadoComLimit = []

        if (ordenado.length < limit) {
          for (let i = 0; i < ordenado.length; i++) {
            ordenadoComLimit.push(ordenado[i])
          }
        } else {
          for (let i = 0; i < limit; i++) {
            ordenadoComLimit.push(ordenado[i])
          }
        }
        return ordenadoComLimit
      } else {
        return ordenado
      }
    },
    // Busca todos registros
    /*   allCities() {
      const data = []
      const parsedJSON = require('./arquivos/mapa_ranking_regional.json')
      parsedJSON.forEach(item => {
        if (item.latitude !== null && item.longitude !== null) {
          data.push(item)
        }
      })
      const ordenando = data.sort((a, b) => {
        if (Number(a.isf) === Number(b.isf)) {
          if (Number(a.desempenho) < Number(b.desempenho)) return 1
          if (Number(a.desempenho) > Number(b.desempenho)) return -1
          return 0
        } else {
          if (Number(a.isf) < Number(b.isf)) return 1
          if (Number(a.isf) > Number(b.isf)) return -1
          return 0
        }
      })
      return ordenando
    }, */

    // Busca todas cidades por estado
    allCitiesByState(uf) {
      const allData = this.dadosOriginaisDaRequisicao
      const data = allData.filter((item) => {
        return item.no_uf === uf
      })
      return data
    },
    // Busca todas cidades por macro região
    citiesByMacroRegions(data, uf, macroRegions) {
      const res = data.filter((item) => {
        return item.no_uf === uf && macroRegions.includes(item.no_macro_regiao)
      })
      return res
    },
    // buscar todas cidades por região
    citiesByRegional(data, uf, regional) {
      const res = data.filter((item) => {
        return item.no_uf === uf && regional.includes(item.no_regiao_saude)
      })
      return res
    },

    citiesByPopulation(population) {
      const allData = this.allCities(true)
      const dataCitiesByPopulation = allData.filter((item) => {
        return population.includes(item.faixa_populacional)
      })
      // Passa a data e o limite de municipios
      return this.ordenando(dataCitiesByPopulation, 100)
    },

    // Popula o select macroRegions
    allMacroRegionByState(uf) {
      const allData = this.dadosOriginaisDaRequisicao
      const states = allData.filter((item) => {
        return item.no_uf === uf
      })
      const dataMacroRegiao = []
      states.forEach((element) => {
        dataMacroRegiao.push(element.no_macro_regiao)
      })
      // removendo valores duplicados
      const result = dataMacroRegiao
        .map((e) => JSON.stringify(e))
        .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
        .map((e) => JSON.parse(e))
      this.macroRegions = result
    },

    allRegionalByState(uf, macroRegiao) {
      const allData = this.dadosOriginaisDaRequisicao
      const states = allData.filter((item) => {
        return item.no_uf === uf && item.no_macro_regiao === macroRegiao
      })
      const dataRegionalByState = []
      states.forEach((element) => {
        dataRegionalByState.push(element.no_regiao_saude)
      })

      // removendo valores duplicados
      const result = dataRegionalByState
        .map((e) => JSON.stringify(e))
        .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
        .map((e) => JSON.parse(e))

      this.regional = result.filter((item) => item !== null)
    },

    async buscarQuadrimestres() {
      try {
        this.loading = true

        let quadrimestres = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/quadrimestres'
        )
        if (quadrimestres) {
          this.quadrimestres = quadrimestres.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    /*  async buscarPorQuadrimestre(event) {
      this.quadrimestre = event.target.value
      try {
        this.loading = true
        let url = ''
        if (this.estado == '') {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/quadrimestre/' +
            this.quadrimestre
        } else {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/estado/' +
            this.estado +
            '/quadrimestre/' +
            this.quadrimestre
        }
        let response = await this.$apiPublic.get(url)
        if (response) {
          this.dados = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }, */
    async onChangeQuadrimestre(event) {
      this.dados = []
      this.dadosOriginaisDaRequisicao = []
      if (event !== null) {
        this.quadrimestre = event.quadrimestre
        this.disabelRegions = false
        this.region = ''
        this.state = ''
        this.states = []
        this.macroRegions = []
        this.population = []
        this.dataFilterCitiesRegion = ''
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []

        // Disabled
        this.disableStates = true
        this.disableMacroRegion = true
        this.disableRegional = true
      } else {
        this.quadrimestre = ''
        this.region = ''
        this.steps = ''
        this.state = ''
        this.states = []
        this.macroRegions = []
        this.population = []
        this.dataFilterCitiesRegion = ''
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []

        // Disabled
        this.disabelRegions = true
        this.disableStates = true
        this.disableMacroRegion = true
        this.disableRegional = true
      }
    },

    /*
    Estilização
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     */
    getRadius(desempenho) {
      const value = parseFloat(desempenho)
      const result = value / 30
      return result
    },
    getColor(isf) {
      const value = parseFloat(isf)
      if (value < 4.0) {
        return 'red'
      } else if (value > 3.9 && value < 7.0) {
        return 'orange'
      } else if (value > 6.9 && value < 10) {
        return 'green'
      } else {
        return 'blue'
      }
    },
    getIsfText(isf) {
      const value = parseFloat(isf)
      if (value < 4.0) {
        return 'ISF < 4,0'
      } else if (value > 3.9 && value < 7.0) {
        return 'ISF > 3,9 e < 7,0'
      } else if (value > 6.9 && value < 10) {
        return 'ISF > 6,9 e < 10,0'
      } else {
        return 'ISF - 10,0'
      }
    },
    updateInfo(info) {
      switch (info) {
        case 'serie-historica':
          this.info.type = 'serie-historica'
          this.info.title =
            'Gráfico com a série histórica dos indicadores atuais.'
          break
        case 'selo-aps':
          this.info.type = 'selo-aps'
          this.info.title =
            'Municípios que tem tem ISF >= 7 recebem certificado de APS de qualidade.'
          break
        case 'municipio':
          this.info.type = 'municipio'
          this.info.title =
            'Os primeiros da lista são municípios com melhor desempenho, ou seja, ISF mais alto.'
          break
        case 'pre-natal':
          this.info.type = 'pre-natal'
          this.info.title =
            'Proporção de gestantes com pelo menos 6 (seis) consultas pré-natal realizadas, sendo a primeira até a 12ª semana de gestação.'
          break
        case 'hiv-sifilis':
          this.info.type = 'hiv-sifilis'
          this.info.title =
            'Proporção de gestantes com realização de exames para sífilis e HIV.'
          break
        case 'consultas-odontologicas':
          this.info.type = 'consultas-odontologicas'
          this.info.title =
            'Proporção de gestantes com atendimento odontológico realizado.'
          break
        case 'citopatologico':
          this.info.type = 'citopatologico'
          this.info.title = 'Cobertura de exame citopatológico.'
          break
        case 'polio-penta':
          this.info.type = 'polio-penta'
          this.info.title =
            'Proporção de crianças de 1 (um) ano de idade vacinadas na APS contra Difteria, Tétano, Coqueluche, Hepatite B, infecções causadas por Haemophilus Influenzae tipo b e Poliomielite Inativada.'
          break
        case 'hipertensao':
          this.info.type = 'hipertensao'
          this.info.title =
            'Percentual de pessoas hipertensas com Pressão Arterial aferida em cada semestre.'
          break
        case 'hemoglobina-glicada':
          this.info.type = 'hemoglobina-glicada'
          this.info.title =
            'Percentual de diabéticos com solicitação de hemoglobina glicada.'
          break
        case 'isf':
          this.info.type = 'isf'
          this.info.title = 'Indicador Sintético Final.'
          break
        case 'desempenho':
          this.info.type = 'desempenho'
          this.info.title =
            'O desempenho é calculado pela média dos resultados individuais dos indicadores e ponderada pelos pesos de cada indicador multiplicada pelo ISF.'
          break
        default:
          break
      }
    },

    indicadorColor(valor, indicador) {
      const percentual = parseInt(valor)
      switch (indicador) {
        case 'pre-natal':
          if (percentual < 18) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 18 && percentual < 31) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 31 && percentual < 45) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'hiv-sifilis':
          if (percentual < 24) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 24 && percentual < 42) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 42 && percentual < 60) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'consultas-odontologicas':
          if (percentual < 24) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 24 && percentual < 42) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 42 && percentual < 60) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'citopatologico':
          if (percentual < 16) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 16 && percentual < 28) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 28 && percentual < 40) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'polio-penta':
          if (percentual < 38) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 38 && percentual < 67) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 67 && percentual < 95) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'hipertensao':
          if (percentual < 20) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 20 && percentual < 35) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 35 && percentual < 50) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'hemoglobina-glicada':
          if (percentual < 20) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 20 && percentual < 35) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 35 && percentual < 50) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        default:
          break
      }
    },
    /*     async showModal(item) {
      this.$emit('closeMenu')
      this.openedModal = true
      this.municipio = item
      // limpa o gráfico inicialmente
      this.$refs.chartData.updateSeries([])
      try {
        let response = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/resultado/municipio/' +
            item.co_ibge
        )
        if (response) {
          let response2 = response.data
          let array_xaxis = []
          let array_chart_pre_natal = [],
            array_chart_hiv_sifilis = [],
            array_chart_consultas_odontologicas = [],
            array_chart_citologico = [],
            array_chart_imunizacao = [],
            array_chart_hipertensao = [],
            array_chart_hemoglobina = []

          //preencher a legenda
          for (const item of response2) {
            array_xaxis.push(item.quadrimestre)
          }

          for (let i = 0; i < array_xaxis.length; i++) {
            var eixo_x_atual = array_xaxis[i]
            for (const item of response2) {
              var resultado_pre_natal = 0
              var resultado_hiv_sifilis = 0
              var resultado_consultas_odontologicas = 0
              var resultado_citologico = 0
              var resultado_imunizacao = 0
              var resultado_hipertensao = 0
              var resultado_hemoglobina = 0
              if (item.quadrimestre == eixo_x_atual) {
                resultado_pre_natal = item.pn_6_consultas
                resultado_hiv_sifilis = item.pn_hiv_sifilis
                resultado_consultas_odontologicas = item.pn_odontologia
                resultado_citologico = item.citopatologico
                resultado_imunizacao = item.crianca_polio_penta
                resultado_hipertensao = item.pa_hipertensao
                resultado_hemoglobina = item.hg_diabetes
                break
              } else {
                resultado_pre_natal = null
                resultado_hiv_sifilis = null
                resultado_consultas_odontologicas = null
                resultado_citologico = null
                resultado_imunizacao = null
                resultado_hipertensao = null
                resultado_hemoglobina = null
              }
            }
            array_chart_pre_natal.push(resultado_pre_natal)
            array_chart_hiv_sifilis.push(resultado_hiv_sifilis)
            array_chart_consultas_odontologicas.push(
              resultado_consultas_odontologicas
            )
            array_chart_citologico.push(resultado_citologico)
            array_chart_imunizacao.push(resultado_imunizacao)
            array_chart_hipertensao.push(resultado_hipertensao)
            array_chart_hemoglobina.push(resultado_hemoglobina)
          }

          this.$refs.chartData.updateOptions({
            xaxis: {
              categories: array_xaxis
            },
            title: {
              text: `${item.municipio} - ${item.uf}`
            },
            subtitle: {
              text: `Indicadores do Previne Brasil. Fonte: eSUS Feedback, SISAB (${item.quadrimestre})`
            },
            yaxis: {
              min: 0,
              max: 100
            }
          })
          this.$refs.chartData.updateSeries([
            {
              name: 'Consultas pré-natal',
              data: array_chart_pre_natal
            },
            {
              name: 'Exames HIV e Sífilis',
              data: array_chart_hiv_sifilis
            },
            {
              name: 'Consultas odontológicas',
              data: array_chart_consultas_odontologicas
            },
            {
              name: 'Citopatológico',
              data: array_chart_citologico
            },
            {
              name: 'Vacinas',
              data: array_chart_imunizacao
            },
            {
              name: 'Hipertensão',
              data: array_chart_hipertensao
            },
            {
              name: 'Diabéticos',
              data: array_chart_hemoglobina
            }
          ])
        }
      } catch (error) {
        console.log(error)
      }
    },

    async showModalIsf(item) {
      this.$emit('closeMenu')
      this.openedModal = true
      this.municipio = item
      // limpa o gráfico inicialmente
      this.$refs.chartData.updateSeries([])
      try {
        let response = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/resultado/municipio/' +
            item.co_ibge
        )
        if (response) {
          let response2 = response.data
          let array_xaxis = []
          let array_chart_isf = []

          //preencher a legenda
          for (const item of response2) {
            array_xaxis.push(item.quadrimestre)
          }

          for (let i = 0; i < array_xaxis.length; i++) {
            var eixo_x_atual = array_xaxis[i]
            for (const item of response2) {
              var resultado_isf = 0
              if (item.quadrimestre == eixo_x_atual) {
                resultado_isf = item.isf
                break
              } else {
                resultado_isf = null
              }
            }
            array_chart_isf.push(resultado_isf)
          }

          this.$refs.chartData.updateOptions({
            xaxis: {
              categories: array_xaxis
            },
            title: {
              text: `${item.municipio} - ${item.uf}`
            },
            subtitle: {
              text: `Indicador Sintético Final. Fonte: eSUS Feedback, SISAB (${item.quadrimestre})`
            },
            yaxis: {
              min: 0,
              max: 10
            }
          })
          this.$refs.chartData.updateSeries([
            {
              name: 'ISF',
              data: array_chart_isf
            }
          ])
        }
      } catch (error) {
        console.log(error)
      }
    }, */

    /*  async buscarDados() {
      try {
        this.loading = true

        let quadrimestres = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/quadrimestres'
        )
        if (quadrimestres) {
          this.quadrimestres = quadrimestres.data
          this.quadrimestre = quadrimestres.data[0].quadrimestre
        }
        let response = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/resultado/quadrimestre/' +
            this.quadrimestre
        )
        if (response) {
          this.dados = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },*/

    /*    async buscarPorQuadrimestre(event) {
      this.quadrimestre = event.target.value
      try {
        this.loading = true
        let url = ''
        if (this.estado == '') {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/quadrimestre/' +
            this.quadrimestre
        } else {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/estado/' +
            this.estado +
            '/quadrimestre/' +
            this.quadrimestre
        }
        let response = await this.$apiPublic.get(url)
        if (response) {
          this.dados = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }, */

    /*   async buscarPorEstado(event) {
      this.estado = event.target.value
      this.temEstadoSelecionado = true
      try {
        this.loading = true
        let url = ''
        if (this.quadrimestre == '') {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/estado/' +
            this.estado
        } else {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/estado/' +
            this.estado +
            '/quadrimestre/' +
            this.quadrimestre
        }
        let response = await this.$apiPublic.get(url)
        if (response) {
          this.dados = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }, */

    /*     downloadSeloAps(seloApsImg) {
      window.open(`${seloApsImg}&download=true`, '_blank')
    },

    downloadImgPorcentagem(porcentagemImg) {
      window.open(`${porcentagemImg}&download=true`, '_blank')
    }, */

    /*     resetarFiltros() {
      this.estado = ''
      this.nomeMunicipio = ''
      this.temEstadoSelecionado = false
      this.buscarDados()
    }, */

    changeFontColor(isf) {
      if (isf < 4) {
        return 'sh-re-button-isf-red'
      } else if (isf >= 4 && isf < 7) {
        return 'sh-re-button-isf-orange'
      } else if (isf >= 7 && isf <= 9) {
        return 'sh-re-button-isf-green'
      } else if (isf > 9) {
        return 'sh-re-button-isf-blue'
      } else {
        return ''
      }
    },
  },
}
</script>

<style>
.leaflet-container {
  z-index: 5;
}

.grafico-select {
  margin-bottom: 15px;
  background-color: #fff;
}

.caption-map {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-top: 10px;
}

.caption-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
}

.caption-item span {
  width: 15px;
  height: 15px;
  border-radius: 30px;
}

.caption-item h4 {
  font-size: 16px;
  margin: 0;
}

.caption-item.caption-blue span {
  background-color: blue;
}

.caption-item.caption-green span {
  background-color: green;
}

.caption-item.caption-orange span {
  background-color: orange;
}

.caption-item.caption-red span {
  background-color: red;
}
@media screen and (max-width: 656px) {
  .caption-map {
    justify-content: center !important;
  }
  .caption-item {
    flex-direction: column !important;
    text-align: center !important;
  }

  .caption-item h4 {
    font-size: 9px !important;
  }
}
@media screen and (min-width: 657px) and (max-width: 807px) {
}
@media screen and (min-width: 808px) and (max-width: 1023px) {
}
@media screen and (min-width: 1024px) and (max-width: 1265px) {
}
</style>
<style>
.mapa {
  z-index: 0;
}
</style>
<style>
.sh-ri-header {
  width: 100%;
  border-bottom: 1px solid #eeeeee;
  padding: 15px 0;
  margin-bottom: 30px;
}
.sh-ri-header .container {
  max-width: 85vw !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sh-ri-header .logo img {
  width: 160px;
}

.sh-ri-header .titulo {
  width: 100%;
  padding: 20px 0;
}

.sh-ri-header .titulo h1 {
  font-size: 25px;
  text-align: center;
}

.sh-ri-content .container {
  max-width: 85vw !important;
}

.modal-sh .modal-container {
  width: 1050px;
}

.modal-sh .apexcharts-legend.position-top.apexcharts-align-center {
  justify-content: center;
}

.sh-ri-info {
  background-color: #fff;
  padding: 15px;
  margin-bottom: 10px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.sh-ri-info h3 {
  font-size: 17px;
}

.sh-ri-percent {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 500;
}

.sh-ri-percent > div {
  margin: 0 10px;
}

.sh-ri-percent > div:first-child {
  margin-left: 0;
}

.sh-ri-percent span {
  width: 25px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 4px;
}

.sh-ri-percent-red span {
  background-color: red;
}

.sh-ri-percent-orange span {
  background-color: orange;
}

.sh-ri-percent-green span {
  background-color: green;
}

.sh-ri-percent-blue span {
  background-color: blue;
}

.sh-re-button-isf {
  padding: 0 10px;
  cursor: unset;
  font-weight: 700;
}

.sh-ri-percent-red,
.sh-re-button-isf-red {
  color: red;
}

.sh-ri-percent-orange,
.sh-re-button-isf-orange {
  color: orange;
}

.sh-ri-percent-green,
.sh-re-button-isf-green {
  color: green;
}

.sh-ri-percent-blue,
.sh-re-button-isf-blue {
  color: blue;
}

.sh-ri .table .thead-light th,
.sh-ri .table tbody td {
  text-align: center;
}

.sh-ri table thead th:hover {
  cursor: pointer;
  background-color: #ccc;
}

.sh-ri table tbody tr td {
  font-size: 14px !important;
}

.sh-ri table tbody tr td .placement {
  margin-right: 15px;
  font-weight: 700;
  display: inline-block;
}

.sh-ri .btn.btn-default {
  color: #333;
  background-color: #ebebeb;
  border-color: #adadad;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.428571429;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 0px;
  height: 38px;
}

/* .rh-si-icon-grafico{
        padding: 5px 15px;
    } */

.rh-si-icon-grafico img {
  width: 30px;
  cursor: pointer;
}

.selo-aps-img {
  cursor: pointer;
}

.modal-selo-aps img {
  width: 100%;
}

.modal-selo-aps-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sh-ri footer h3 {
  text-align: center;
}

.sh-ri footer a img {
  margin: 25px auto;
  display: table;
  width: 150px;
}

.sh-ri footer p {
  text-align: center;
}

.sh-ri .tem-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sh-ri .btn-options button {
  background: transparent;
  border: navajowhite;
  box-shadow: none;
  color: #000;
}

@media screen and (max-width: 656px) {
  .sh-ri-header .container {
    max-width: 100vw !important;
  }
  .sh-ri-content .container {
    max-width: 100vw !important;
  }
  .sh-ri-header .logo img {
    width: 45px !important;
  }
  .sh-ri-header .titulo h1 {
    font-size: 15px;
    text-align: center;
  }
  .modal-sh .modal-container {
    width: 100%;
  }
  .sh-ri-info {
    margin-top: 15px;
  }
}

@media screen and (min-width: 657px) and (max-width: 807px) {
  .sh-ri-header .container {
    max-width: 100vw !important;
  }
  .sh-ri-content .container {
    max-width: 100vw !important;
  }
  .sh-ri-header .logo img {
    width: 45px !important;
  }
  .sh-ri-header .titulo h1 {
    font-size: 15px;
    text-align: center;
  }
  .modal-sh .modal-container {
    width: 100%;
  }
  .sh-ri-info {
    margin-top: 15px;
  }
}

@media screen and (min-width: 808px) and (max-width: 1023px) {
  .sh-ri-header .container {
    max-width: 100vw !important;
  }
  .sh-ri-content .container {
    max-width: 100vw !important;
  }
  .sh-ri-header .logo img {
    width: 45px !important;
  }
  .sh-ri-header .titulo h1 {
    font-size: 15px;
    text-align: center;
  }
  .modal-sh .modal-container {
    width: 100%;
  }
  .sh-ri-info {
    margin-top: 15px;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1265px) {
  .sh-ri-header .container {
    max-width: 100vw !important;
  }
  .sh-ri-content .container {
    max-width: 100vw !important;
  }
  .sh-ri-header .logo img {
    width: 45px !important;
  }
  .sh-ri-header .titulo h1 {
    font-size: 15px;
    text-align: center;
  }
  .modal-sh .modal-container {
    width: 100%;
  }
  .sh-ri-info {
    margin-top: 15px;
  }
}
</style>
<style scoped>
.section-title-index {
  display: flex;
  align-items: center;
  gap: 1%;
  padding: 0;
  margin: 0;
  border-top: 0;
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: 3px solid #eee;
  font-size: 18px;
  color: #000;
  font-weight: 600;
  position: relative;
}
.section-title-index::before {
  content: '';
  display: block;
  width: 50px;
  height: 3px;
  background-color: #0d98bb;
  position: absolute;
  bottom: -3px;
  left: 0;
}
.pdf-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.pdf-container .spinner {
  margin-right: 20px;
  color: #0fafd7;
}
.content .content-main {
  padding: 20px 30px 150px 20px;
}
</style>
<style src="./styles.scss" scoped lang="scss" />
